module.exports = __webpack_public_path__ + "static/media/elDesafio.94c68d36.webp";